import {
  __spreadProps,
  __spreadValues
} from "./chunk-CWMXXUWU.js";

// src/styles/themeDefaults/buttons.tsx
var buttonBorderRadiuses = [8, 32, 999];
var allowedButtonTypographyTypes = [
  "Body",
  "Body Strong",
  "Title",
  "Label",
  "Label Moderate",
  "Label Strong"
];
var buttonsThemeBase = {
  defaultSize: "Small",
  defaultTypographyType: "Body Strong",
  defaultColor: "text",
  defaultBorderRadius: 32,
  defaultBackgroundColor: "bg",
  defaultBorderColor: "bg",
  defaultHoverBackgroundColor: "bg",
  defaultHoverBorderColor: "bg",
  defaultActiveBackgroundColor: "bg",
  defaultActiveBorderColor: "bg",
  defaultOutlineOffset: 1,
  defaultPaddingsY: {
    ExtraSmall: 4,
    Small: {
      short: 8,
      regular: 12
    },
    Schmedium: 12,
    Medium: 12,
    Mlarge: 12,
    Large: 12
  },
  kinds: {}
};
var defaultButtonsTheme = __spreadProps(__spreadValues({}, buttonsThemeBase), {
  kinds: {
    primary: {
      defaultColor: "bg",
      defaultBackgroundColor: "c9Neutral",
      defaultBorderColor: "c9Neutral",
      defaultHoverBackgroundColor: "c8Neutral",
      defaultHoverBorderColor: "c8Neutral",
      defaultActiveBackgroundColor: "c7Neutral",
      defaultActiveBorderColor: "c7Neutral"
    },
    ghost: {
      defaultBackgroundColor: "transparent",
      defaultHoverBackgroundColor: "transparent",
      defaultHoverBorderColor: "transparent",
      defaultPaddingsY: {
        ExtraSmall: 0,
        Small: 0,
        Schmedium: 0,
        Medium: 0,
        Mlarge: 0,
        Large: 0
      }
    },
    quaternary: {
      defaultBackgroundColor: "transparent",
      defaultBorderColor: "gray80",
      defaultHoverBackgroundColor: "transparenta02",
      defaultHoverBorderColor: "gray80",
      defaultActiveBackgroundColor: "transparenta08",
      defaultActiveBorderColor: "gray80"
    },
    transparent: {
      defaultBackgroundColor: "transparent",
      defaultBorderColor: "transparent",
      defaultHoverBackgroundColor: "transparenta02",
      defaultHoverBorderColor: "transparent",
      defaultActiveBackgroundColor: "transparenta08",
      defaultActiveBorderColor: "transparent"
    },
    secondary: {
      defaultBackgroundColor: "bg",
      defaultBorderColor: "gray90",
      defaultHoverBackgroundColor: "bg",
      defaultHoverBorderColor: "gray85",
      defaultActiveBackgroundColor: "bg",
      defaultActiveBorderColor: "gray80"
    },
    linkLight: {
      defaultColor: "link",
      defaultBackgroundColor: "linkLight",
      defaultBorderColor: "transparent",
      defaultHoverBackgroundColor: "grayBlue93",
      defaultHoverBorderColor: "grayBlue93",
      defaultActiveBackgroundColor: "grayBlue92",
      defaultActiveBorderColor: "grayBlue92"
    },
    warning: {
      defaultColor: "danger",
      defaultBackgroundColor: "red42a10",
      defaultBorderColor: "transparent",
      defaultHoverBackgroundColor: "red42a20",
      defaultHoverBorderColor: "transparent",
      defaultActiveBackgroundColor: "red42a30",
      defaultActiveBorderColor: "transparent"
    },
    tertiary: {
      defaultColor: "bg",
      defaultBackgroundColor: "grayBlue9",
      defaultHoverBackgroundColor: "grayBlue12",
      defaultActiveBackgroundColor: "grayBlue14"
    },
    blue39: {
      defaultBorderColor: "blue39",
      defaultColor: "gray98"
    },
    blue43: {
      defaultColor: "white"
    },
    green33: {
      defaultColor: "white"
    },
    purple55: {
      defaultColor: "white"
    },
    danger: {
      defaultColor: "white"
    }
  }
});

export {
  buttonBorderRadiuses,
  allowedButtonTypographyTypes,
  buttonsThemeBase,
  defaultButtonsTheme
};
